import { Calendar, FileText, Calculator, Users, Clock, ClipboardList, Palette, DollarSign } from "lucide-react";
import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";

const EventStaffingIndustry = () => (
  <IndustryPlaceholderPage
    name="Event Staffing"
    icon={Calendar}
    iconColor="text-warning"
    iconBg="bg-[hsl(var(--warning)/0.15)]"
    headline="Event Staffing Proposals"
    tagline="in Minutes"
    description="Guardian Pro AI is building a dedicated suite for event staffing companies. Generate professional crew proposals, calculate labor costs with overtime, manage shift schedules, and send branded staffing agreements — all from one platform."
    valueProps={[
      { title: "Crew Proposals in Minutes", description: "Enter event details, crew roles, and rates — our AI builds a polished staffing proposal ready to send." },
      { title: "Accurate Labor Costing", description: "Automatically calculate regular and overtime costs across multiple shifts, roles, and crew sizes." },
      { title: "Event-Specific Contracts", description: "Use pre-built legal templates designed for event staffing, including load-in/load-out, cancellation, and overtime clauses." },
    ]}
    features={[
      { icon: Calculator, label: "Labor Cost Calculator" },
      { icon: Clock, label: "Shift Scheduling" },
      { icon: FileText, label: "PDF Proposals" },
      { icon: Users, label: "Crew Role Management" },
      { icon: ClipboardList, label: "Event Templates" },
      { icon: DollarSign, label: "Overtime Tracking" },
      { icon: Calendar, label: "Multi-Day Events" },
      { icon: Palette, label: "Custom Branding" },
    ]}
    benefits={[
      "AI-generated crew proposals tailored to each event type",
      "Dynamic labor cost calculator with overtime multipliers",
      "Shift scheduling and crew role management",
      "Professional PDF exports with your branding",
      "Contract generator with event-specific legal templates",
      "Client portal for proposal review and e-signatures",
    ]}
    proposalTemplates={[
      "Corporate Event Staffing",
      "Concert & Festival Crew",
      "Wedding & Social Event Staff",
      "Sports Event Personnel",
      "Trade Show & Expo Staff",
    ]}
    contractTemplates={[
      "Standard Event Staffing Agreement",
      "Festival & Concert Crew Contract",
      "Corporate Event Staffing Agreement",
    ]}
    faq={[
      { q: "What types of events does this support?", a: "Corporate events, concerts, festivals, weddings, trade shows, sports events, and more. Each proposal is tailored to the event type." },
      { q: "Can I manage different crew roles and rates?", a: "Yes — add unlimited crew roles (stage hands, bartenders, security, etc.) each with their own headcount and hourly rate." },
      { q: "Does it handle overtime calculations?", a: "Absolutely. Set your overtime threshold and multiplier, and the system calculates regular vs. overtime costs automatically." },
      { q: "Can I create contracts from proposals?", a: "Yes. The contract generator auto-fills event details, crew plans, and costs from your proposals into professional legal templates." },
      { q: "Do clients need an account to sign contracts?", a: "No. Clients receive a secure link to review and digitally sign contracts without creating an account." },
      { q: "When will Event Staffing be available?", a: "We're actively developing this module. Join the waitlist to get early access and be notified as soon as it launches." },
    ]}
    ctaHeadline="Ready to streamline your event staffing?"
    ctaDescription="Join event staffing agencies preparing to automate crew proposals and contracts with Guardian Pro AI."
  />
);

export default EventStaffingIndustry;
